module.exports = __webpack_public_path__ + "img/celebration-animate.5a0b91b5.svg";